import type { Agent, Post, Project, Skill, Stats } from './index'
import LandingFooterCloud from './LandingFooterCloud'
import LandingFooterServices from './LandingFooterServices'
import LandingFooterShowcase from './LandingFooterShowcase'

interface Props {
  stats: Stats; loading: boolean; projects: Project[]; skills: Skill[]; agents: Agent[]; posts: Post[]
}

export default function LandingFooter({ stats, loading, projects, skills, agents, posts }: Props) {
  return (
    <>
      <LandingFooterShowcase stats={stats} agents={agents} posts={posts} projects={projects} loading={loading} />
      <LandingFooterCloud projects={projects} skills={skills} loading={loading} />
      <LandingFooterServices stats={stats} loading={loading} />
    </>
  )
}
